/* eslint-disable react/button-has-type */
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { linkToStep } from '../../utilities/linkToStep';

import './TitleBar.css';

const TitleBar = ({
  step,
  title,
  sessionName,
  onConfirmAll,
  showConfirmAllButton,
  disabled = false
}) => (
  <div className="title-bar">
    <div className="title-content">
      <Link to={() => linkToStep(6)}>
        <FontAwesomeIcon icon={faArrowLeft} className="back-icon" /> Step {step - 1}: Review Details
      </Link>
      <h2>Step {step}: <strong>{title}</strong> for <span className="subtitle">‘{sessionName}’</span></h2>
    </div>
    {showConfirmAllButton && <button className={`confirm-button ${disabled ? 'disabled' : ''} `} onClick={onConfirmAll}>Confirm All</button>}
  </div>
);
export default TitleBar;
